import styled from 'styled-components'

import {
  COLORS,
  CSS_ELEMENTS_RESETS,
  media,
  THEME,
  typeScale,
} from '../../styles'
import Skeleton from '../Skeleton'
import RatingStars from '../RatingStars'
import RecipeAuthorBadge from '../RecipeAuthorBadge'
import Icon from '../Icon'
import NavLink from '../NavLink'

const Styled = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-flow: column nowrap;
  padding: 2.4rem;
  position: relative;
  transition: padding-top 0.2s ease-out;
  padding-top: ${({ isVideoPlayed }) => (isVideoPlayed ? '2.4rem' : '0')};
  ${media.medium`
    padding: 2.4rem 3.2rem;
  `}
`
Styled.goBack = styled.button`
  ${CSS_ELEMENTS_RESETS.button};
  padding: 0.4rem;
  width: 4rem;
  height: 4rem;
  border-radius: 9999px;
  margin: 0 0.8rem 0 0;
  position: absolute;
  left: 2.4rem;
  top: 0;
  ${media.medium`
    top: 2.4rem;
    left: 3.2rem;
  `}
`
Styled.title = styled.h1`
  ${typeScale('headline1')};
  flex: 1;
  text-align: center;
  margin-bottom: 1.6rem;
  padding: 0 4.8rem;
  order: 2;
  width: 100%;
`
Styled.titleSkeleton = styled(Skeleton)`
  height: 3rem;
  width: 66%;
  display: inline-block;
  margin: 0 auto;
  border-radius: 1.9rem;
`
Styled.editButton = styled(NavLink)`
  position: absolute;
  right: 2.4rem;
  top: 2.4rem;
  background-color: ${COLORS.primary};
  padding: 0.8rem 1.2rem;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`
Styled.editButtonLabel = styled.span`
  ${typeScale('caption')};
  color: ${COLORS.white};
  display: inline-block;
  padding-left: 0.4rem;
`
Styled.editButtonIcon = styled(Icon)`
  width: 1.6rem;
  height: 1.6rem;
`
Styled.ratingAverage = styled.a`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  order: 3;
  text-decoration: none;
`
Styled.ratingStars = styled(RatingStars)`
  display: flex;
  justify-content: center;
  width: 100%;
`
Styled.ratingCount = styled.span`
  ${typeScale('caption')};
  display: block;
  text-align: center;
  margin: 0.4rem auto;
  color: ${THEME.COLORS.foreground.secondary};
`
Styled.ratingCountSkeleton = styled(Skeleton)`
  height: 1rem;
  width: 20%;
  display: inline-block;
  order: 3;
  margin: 1rem auto;
  border-radius: 1rem;
`
Styled.description = styled.p`
  text-align: center;
  order: 4;
  width: 100%;
  padding-top: 1.6rem;
`
Styled.author = styled(RecipeAuthorBadge)`
  order: 1;
  width: 100%;
  padding: 0.8rem 4.8rem 1.6rem;
`
Styled.preview = styled.p`
  ${typeScale('caption', { lineHeight: '2.4rem' })};
  text-align: center;
  order: 1;
  width: 100%;
  padding: 0.8rem 4.8rem 1.6rem;
`

export default Styled
